var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeProductivity2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5235:28865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4512 14.7403C32.4512 13.4961 31.8723 12.3228 30.8849 11.5658L18.8849 2.36585C17.4491 1.26509 15.4532 1.26509 14.0174 2.36585L2.01745 11.5658C1.03008 12.3228 0.451172 13.4961 0.451172 14.7403V26.9C0.451172 29.1091 2.24203 30.9 4.45117 30.9H28.4512C30.6603 30.9 32.4512 29.1091 32.4512 26.9V14.7403Z",
    fill: "#FFAB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4102 5.30005H3.49023V28.66H29.4102V5.30005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0516 9.78003H10.8516V10.74H22.0516V9.78003Z",
    fill: "#FDF4E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0905 12.98H7.81055V14.1H25.0905V12.98Z",
    fill: "#FDF4E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0905 16.1801H7.81055V17.3001H25.0905V16.1801Z",
    fill: "#FDF4E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4512 30.9C32.0035 30.9 32.4512 30.4522 32.4512 29.9V14.7933C32.4512 13.9644 31.5006 13.4954 30.8427 13.9997L17.0596 24.5668C16.7007 24.842 16.2017 24.842 15.8427 24.5668L2.0596 13.9997C1.40176 13.4954 0.451172 13.9644 0.451172 14.7933V29.9C0.451172 30.4522 0.898887 30.9 1.45117 30.9H31.4512Z",
    fill: "url(#paint0_linear_5235:28865)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0175 20.4993C15.4532 19.3985 17.4491 19.3985 18.8849 20.4993L23.0932 23.7256C26.1269 26.0515 24.4821 30.9001 20.6595 30.9001H12.2429C8.42021 30.9001 6.77546 26.0515 9.80914 23.7256L14.0175 20.4993Z",
    fill: "#FFAB00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5235:28865",
    x1: 16.4512,
    y1: 12.7664,
    x2: 16.4512,
    y2: 30.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAB00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5235:28865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.451172 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeProductivity2);
export default __webpack_public_path__ + "static/media/homeProductivity_2.2c0ddabb.svg";
export { ForwardRef as ReactComponent };